// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pin-off.js';

import { paths } from '../generated/pin-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pin-off', Original, paths);
